import React from 'react';
import Modal from '../../../Modal/Modal';
import { VoucherFromDom, VoucherDesign } from './VoucherActions';

import './VoucherModal.scss';

interface Props {
    modalVisible: boolean;
    updateModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
    updateVoucherItem: React.Dispatch<React.SetStateAction<VoucherFromDom>>;
    designs: VoucherDesign[];
    voucherItem: VoucherFromDom;
}

const VoucherModal: React.FunctionComponent<Props> = (props) => {
    return (
        <Modal
            visible={props.modalVisible}
            toggleVisibility={() => props.updateModalVisible(false)}
            centerHorizontally={true}
        >
            <div className="voucher-modal">
                <div className="row">
                    {props.designs.map((design) => (
                        <div key={design.name} className="col-sm-6 col-md-3 col-lg-4">
                            <button
                                onClick={() => {
                                    props.updateVoucherItem((voucherItem) => ({
                                        ...voucherItem,
                                        designName: design.name,
                                    }));
                                    props.updateModalVisible(false);
                                }}
                                className={[
                                    'voucher-modal__button',
                                    props.voucherItem.designName === design.name ? 'voucher-modal__button--active' : '',
                                ].join(' ')}
                            >
                                <div className="voucher-modal__design">
                                    <span className="voucher-modal__overlay">auswählen</span>
                                    <img src={design.largeImage} className="img-fluid" />
                                </div>
                            </button>
                        </div>
                    ))}
                </div>
            </div>
        </Modal>
    );
};

export default VoucherModal;
